module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.chat.lastUpdated && _vm.chat.lastUpdated >= _vm.after) ? _c('div', [_c('div', {
    staticClass: "chat-conversation"
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.members.length > 2) ? [_c('h5', _vm._l((_vm.members), function(member, id) {
    return _c('first-name', {
      key: member['.key'],
      attrs: {
        "member": member['.key'],
        "deli": ',',
        "presence": true,
        "showDeli": (id + 1 < _vm.members.length)
      }
    })
  }))] : _vm._l((_vm.members), function(member, id) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('full-name', {
      key: member['.key'],
      attrs: {
        "member": member['.key'],
        "presence": true
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "body",
    attrs: {
      "id": "conversation"
    }
  }, _vm._l((_vm.messages), function(message, id) {
    return (message.createdAt >= _vm.after) ? _c('message', {
      key: id,
      attrs: {
        "message": message,
        "index": id,
        "allmessages": _vm.messages
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message",
    attrs: {
      "type": "text",
      "placeholder": "Type a message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.send($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('options', {
    attrs: {
      "chatID": _vm.id
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86481af8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/conversation/Conversation.vue
// module id = 722
// module chunks = 1